import React from 'react';
import style from './App.module.scss';
import { ConfigPanel, Layer } from '../ConfigPanel';
import { GlobalColors, ItemSchemas } from '../../assets';
import { Layout } from 'antd';
import { Output } from '../Output';
import { useArrayActions } from '../../hooks/useArrayActions';

// TODO: modularise this using https://ant.design/docs/react/use-with-create-react-app#Advanced-Guides
import 'antd/dist/antd.css';


function App() {
  const [globalColors, setGlobalColors] = React.useState(
    GlobalColors.colors.map(m => m.color)
  );
  // const [colorActions] = useArrayActions(colorArr, setColorArr);

  const initLayers = React.useMemo(
    () =>
      Object.keys(ItemSchemas)
        .map(id => ItemSchemas[id])
        .filter(schema => schema.default)
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map(schema => ({
          item: schema.id,
          colors: schema.colors.map(c => c.color),
        })),
    []
  );
  const [itemArr, setItemArr] = React.useState<Layer[]>(initLayers);
  const [itemActions, itemArrActions] = useArrayActions(itemArr, setItemArr);

  return (
    <Layout style={{ height: '100vh' }}>
      <Layout.Header>
        <span className={style.logo}>TikToken</span>
        {/* <Menu theme='dark' mode='horizontal'>
          <Menu.Item key='1'>nav 1</Menu.Item>
          <Menu.Item key='2'>nav 2</Menu.Item>
          <Menu.Item key='3'>nav 3</Menu.Item>
        </Menu> */}
      </Layout.Header>
      <Layout className={style.App}>
        <Layout.Content className={style.output}>
          <Output layers={itemArr} globalColors={globalColors} />
        </Layout.Content>
        <Layout.Sider width={500} theme='light' className={style.sider}>
          <ConfigPanel
            items={itemActions}
            itemArrActions={itemArrActions}
            itemSchemas={ItemSchemas}
            globalColors={globalColors}
            setGlobalColors={setGlobalColors}
          />
        </Layout.Sider>
      </Layout>
    </Layout>
  );
}

export default App;
